import $ from 'jquery';

export default function (elements, Widget, instanceName) {
  $(elements).each((i, element) => {
    const $element = $(element);
    const instance = new Widget($element);

    if (instanceName) {
      $element.data(instanceName, instance);
    }
  });
}
